export const Types = {
  SET_RECORD: 'SET_RECORD',
  SAVE_LIST_ORDER_EXPORT_CSV : 'SAVE_LIST_ORDER_EXPORT_CSV',
}
